@if (_sessions$ | async; as sessions) {
  @if (sessions.length > 0) {
    <h1>Jouw testen ({{ sessions.length }})</h1>
    <ion-list>
      @for (session of sessions; track session) {
        <ion-nav-link
          routerDirection="forward"
          [component]="questionnairePage"
          [componentProps]="{ sessionId: session.id }"
        >
          <ion-item
            button
            [attr.data-session-id]="session.id"
            [attr.data-questionnaire-id]="session.questionnaire.id"
            [attr.data-totalQuestions]="session.totalQuestions"
            [attr.data-questionsCorrect]="session.questionsCorrect"
            [attr.data-grade]="session.grade"
          >
            <ion-label
              >{{ session.questionnaire.title }}
              @for (tag of session.tags; track tag) {
                <ion-badge color="secondary" slot="end">{{ tag }}</ion-badge>
              }
            </ion-label>
            @if (session.startedAt && !session.finishedAt) {
              <ion-icon name="hourglass-outline" slot="end" />
            }
            @if (session.finishedAt) {
              <ion-icon name="checkmark-outline" slot="end" />
            }
          </ion-item>
        </ion-nav-link>
      }
    </ion-list>
  } @else {
    <h1>Jouw testen</h1>
    <p>Er zijn helaas geen testen beschikbaar.</p>
  }
} @else {
  <h1>Jouw testen</h1>
  <ion-skeleton-text [animated]="true" />
  <ion-skeleton-text [animated]="true" />
  <ion-skeleton-text [animated]="true" />
}
